import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import expenseService from "../Services/expense";
import Loading from "../Modals/Loading";
import DeleteModal from "../Components/DeleteModal";
import { HiOutlineTrash } from "react-icons/hi";
import Head from "../Components/Head";

const Expenses = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [deleteID, setDeleteID] = useState();
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [totalExpense, setTotalExpense] = useState([]);

  const initiateDelete = (id) => {
    setOpen(!open);
    setDeleteID(id);
  };

  useEffect(() => {
    expenseService
      .fetchAllBySpecificDate({
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
      })
      .then((res) => {
        setFilteredData(res.expenses);
        const totalAmount = res.expenses.reduce(
          (total, item) => total + item.amount,
          0,
        );
        setTotalExpense(totalAmount);
      });
  }, [startDate, endDate]);

  const handleDelete = () => {
    setDeleting(true);
    expenseService.delete(deleteID).then((res) => {
      setDeleting(false);
      setTrigger(!trigger);
    });
  };

  useEffect(() => {
    setLoading(true);
    expenseService.fetchAllExpenses().then((res) => {
      setFilteredData(res.expenses);
      const totalAmount = res.expenses.reduce(
        (total, item) => total + item.amount,
        0,
      );
      setTotalExpense(totalAmount);
      setLoading(false);
    });
  }, [trigger]);

  return (
    <div className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <DeleteModal
        open={open}
        setOpen={setOpen}
        deleteFunction={handleDelete}
        deleting={deleting}
      />
      {loading ? (
        <div className="flex justify-center items-center">
          <Loading />
        </div>
      ) : (
        <div>
          <Head
            heading={"Expenses"}
            button_text={"Add Expense"}
            navigation={() => navigate("/expenses/add")}
          />

          <div className="flex gap-8 mt-4">
            <div className="flex flex-col gap-1">
              <label className="primary-label">Start Date</label>
              <input
                type="date"
                name="from"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="primary-input"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="primary-label">End Date</label>
              <input
                type="date"
                name="from"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="primary-input"
              />
            </div>
          </div>
          <div className="table-div">
            <table>
              <thead>
                <tr className="border-y-2 text-left w-full text-black text-[10px]">
                  <th className="rounded-tl-xl w-[3%] py-4 pl-4">Date</th>
                  <th className="w-[2%] py-4">Voucher Id</th>
                  <th className="w-[5%] py-4">Title</th>
                  <th className="w-[3%] py-4">Account</th>
                  <th className="w-[3%] py-4">Amount</th>
                  <th className="w-[8%] py-4">Notes</th>
                  <th className="rounded-tr-xl w-[1%] py-4">Delete</th>
                </tr>
              </thead>
              <tbody>
                {filteredData?.map((expense, index) => (
                  <tr
                    key={index}
                    className="bg-accent border-b border-gray-100 text-left"
                  >
                    <td className=" py-3 w-[2%] pl-4 font-bold">
                      {expense.date}
                    </td>
                    <td className=" py-3 w-[2%]">{expense?.voucher}</td>
                    <td className=" py-3 w-[2%] font-semibold">
                      {expense.title}
                    </td>
                    <td className=" py-3 w-[5%]">{expense.account}</td>
                    <td className=" py-3 w-[3%] font-bold text-red-600">
                      {expense.amount} AED
                    </td>
                    <td className="py-3 w-[8%] text-[10px]">{expense.note}</td>
                    <td className="py-3 w-[1%]">
                      <button
                        onClick={() => initiateDelete(expense.id)}
                        className="px-4"
                      >
                        <HiOutlineTrash className="h-4 w-4 text-red-500" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="font-bold text-gray-500 text-lg">
            Total Expense during the selected period :{" "}
            <div className="bg-white shadow-md inline border rounded-md">
              <span className="text-red-600 px-2 py-2">{totalExpense}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Expenses;
